import React from "react";
import SchoolHeaderLogos from "../top/SchoolHeaderLogos/SchoolHeaderLogos";
import { useBreakpoint } from "shared/hooks/useBreakpoint";
const SchoolLogo = () => {
    const { breakpoint } = useBreakpoint();
    return (
        // <div>
            <SchoolHeaderLogos variant={breakpoint} />
        // </div>
    );
};


export default SchoolLogo;